import { useState, useEffect } from 'react'
import ReactDOM from 'react-dom'

export const Portal = ({ children, className = 'root-portal', element = 'div', container: mountPoint = document.body }) => {
  const [container] = useState(() => {
    const el = document.createElement(element)
    el.classList.add(className)
    return el
  })

  useEffect(() => {
    mountPoint.appendChild(container)
    return () => {
      mountPoint.removeChild(container)
    }
  }, [mountPoint])

  return ReactDOM.createPortal(children, container)
}
